import { toLower, uniqBy } from 'lodash';

export const getListKeywords = array => {
  return array
    .join(' ')
    .split(' ')
    .filter(Boolean);
};

export const getUniqueKeywords = listKeyword => {
  return uniqBy(listKeyword, toLower).map(keyword => ({
    value: keyword,
    active: true
  }));
};
